module.exports = __webpack_public_path__ + "img/bcorp.5427b43e.png";